import React from 'react';
import Icon from './Icon';
import { founderVision } from '../data';

export default function Founder() {
  return (
    <section className="section" id="founder">
      <div className="container">
        <div className="founder">
          <div className="founder__quote">
            <span className="founder__mark">&ldquo;</span>
            <p className="founder__text">
              We are not just building platforms, we are building the future of
              human experiences and celebrations.
            </p>
            <div className="founder__by">
              <span className="founder__name">&ndash; Pradhyumna T Venkat</span>
              <span className="founder__role">
                Founder &amp; CEO, Caladium Systems
              </span>
            </div>
            <img
              className="founder__photo"
              src={`${process.env.PUBLIC_URL}/images/Caladium_MD.png`}
              alt="Pradhyumna T Venkat"
            />
          </div>

          <div className="founder__vision">
            <h3 className="founder__vision-title">
              What We Are Building
            </h3>
            <p className="founder__vision-sub">The Future We Envision</p>
            <div className="founder__vision-list">
              {founderVision.map((v) => (
                <div className="fvision" key={v.title}>
                  <span className="fvision__icon">
                    <Icon name={v.icon} size={22} />
                  </span>
                  <div className="fvision__text">
                    <strong>{v.title}</strong>
                    <span>{v.desc}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
